import { NgModule } from "@angular/core";
import { Route, RouterModule } from "@angular/router";
import { PoCoComponent } from "src/app/view/research/po-co/po-co.component";
import { CentreComponent } from "src/app/view/research/centre/centre.component";
import { CollaborativeComponent } from "src/app/view/research/collaborative/collaborative.component";
import { FdpComponent } from "src/app/view/research/fdp/fdp.component";
import { GuestComponent } from "src/app/view/research/guest/guest.component";
import { MajorProjectComponent } from "src/app/view/research/major-project/major-project.component";
import { MinorProjectComponent } from "src/app/view/research/minor-project/minor-project.component";
import { PublicationComponent } from "src/app/view/research/publication/publication.component";
import { ResearchComponent } from "src/app/view/research/research.component";
import { ResultComponent } from "src/app/view/research/result/result.component";
import { ScholarshipComponent } from "src/app/view/research/scholarship/scholarship.component";
import { SeminarComponent } from "src/app/view/research/seminar/seminar.component";
import { StudentProjectComponent } from "src/app/view/research/student-project/student-project.component";
import { WorkshopComponent } from "src/app/view/research/workshop/workshop.component";
import { WTwotwoTwothreeComponent } from "src/app/view/research/workshop/w-twotwo-twothree/w-twotwo-twothree.component";
import { WTwooneTwotwoComponent } from "src/app/view/research/workshop/w-twoone-twotwo/w-twoone-twotwo.component";
import { SpTwotwoTwothreeComponent } from "src/app/view/research/student-project/sp-twotwo-twothree/sp-twotwo-twothree.component";
import { SpTwooneTwotwoComponent } from "src/app/view/research/student-project/sp-twoone-twotwo/sp-twoone-twotwo.component";
import { MouComponent } from "src/app/view/research/mou/mou.component";
import { ScTwotwoTwothreeComponent } from "src/app/view/research/scholarship/sc-twotwo-twothree/sc-twotwo-twothree.component";
import { ScTwooneTwotwoComponent } from "src/app/view/research/scholarship/sc-twoone-twotwo/sc-twoone-twotwo.component";
import { WTwothreeTwofourComponent } from "src/app/view/research/workshop/w-twothree-twofour/w-twothree-twofour.component";
import { SpTwothreeTwofourComponent } from "src/app/view/research/student-project/sp-twothree-twofour/sp-twothree-twofour.component";
import { ScTwothreeTwofourComponent } from "src/app/view/research/scholarship/sc-twothree-twofour/sc-twothree-twofour.component";
import { FcTwothreeTwofourComponent } from "src/app/view/research/mou/fc-twothree-twofour/fc-twothree-twofour.component";
import { FcTwotwoTwothreeComponent } from "src/app/view/research/mou/fc-twotwo-twothree/fc-twotwo-twothree.component";
import { OnenineTwozeroComponent } from "src/app/view/research/fdp/onenine-twozero/onenine-twozero.component";
import { TwothreeTwofourComponent } from "src/app/view/research/fdp/twothree-twofour/twothree-twofour.component";
import { FcTwofourTwofiveComponent } from "src/app/view/research/mou/fc-twofour-twofive/fc-twofour-twofive.component";
import { FcTwofiveTwosixComponent } from "src/app/view/research/mou/fc-twofive-twosix/fc-twofive-twosix.component";
import { ResearchDevelopmentCellComponent } from "src/app/view/research/research-development-cell/research-development-cell.component";
import { ResearchEntrepreneurshipCellComponent } from "src/app/view/research/entrepreneurship-cell/research-entrepreneurship-cell.component";

const route: Route[] = [
    {
        path: '', component: ResearchComponent, children: [
            { path: 'research-centre', component: CentreComponent },
            { path: 'major-research-project', component: MajorProjectComponent },
            { path: 'minor-research-project', component: MinorProjectComponent },
            {
                path: 'student-project', component: StudentProjectComponent, children: [
                    { path: '2023-2024', component: SpTwothreeTwofourComponent },
                    { path: '2022-2023', component: SpTwotwoTwothreeComponent },
                    { path: '2021-2022', component: SpTwooneTwotwoComponent },
                ]
            },
            { path: 'publication', component: PublicationComponent },
            { path: 'Seminar-conference', component: SeminarComponent },
            {
                path: 'workshops', component: WorkshopComponent, children: [
                    { path: '2022-2023', component: WTwotwoTwothreeComponent },
                    { path: '2021-2022', component: WTwooneTwotwoComponent },
                    { path: '2023-2024', component: WTwothreeTwofourComponent },
                ]
            },
            { path: 'guest-lecture', component: GuestComponent },
            // {path:'fdps',component:FdpComponent},
            {
                path: 'scholarship', component: ScholarshipComponent, children: [
                    { path: '2023-2024', component: ScTwothreeTwofourComponent },
                    { path: '2022-2023', component: ScTwotwoTwothreeComponent },
                    { path: '2021-2022', component: ScTwooneTwotwoComponent },
                ]
            },
            { path: 'collaborative', component: CollaborativeComponent },
            { path: 'research-development-cell', component: ResearchDevelopmentCellComponent },
            { path: 'entrepreneurship-cell', component: ResearchEntrepreneurshipCellComponent },
            { path: 'result', component: ResultComponent },
            { path: 'pos-cos', component: PoCoComponent },
            {
                path: 'mou', component: MouComponent, children: [
                    { path: '2025-2026', component: FcTwofiveTwosixComponent },
                    { path: '2024-2025', component: FcTwofourTwofiveComponent },
                    { path: '2023-2024', component: FcTwothreeTwofourComponent },
                    { path: '2022-2023', component: FcTwotwoTwothreeComponent },
                ]
            },
            {
                path: 'fdps', component: FdpComponent, children: [
                    { path: '2023-2024', component: TwothreeTwofourComponent },
                    { path: '2019-2020', component: OnenineTwozeroComponent },
                ]
            },
        ]
    }
]
@NgModule({
    imports: [
        RouterModule.forChild(route)
    ],
    exports: [
        RouterModule
    ]
})
export class ResearchRoutingModule { }